import { saveAs } from 'file-saver';
import Cookies from 'universal-cookie';

import { wave } from './config';

const cookies = new Cookies();

export async function postGoogleWallet(card) {
  const authorization = cookies.get('token');
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  const body = {
    cardNumber: card,
  };
  try {
    const response = await wave.post('/v3/users/mobile-passes/google-wallet', body, { headers });
    const { googleJwt } = response.data;
    return { googleJwt };
  } catch (error) {
    const userMessage =
      error.response?.data?.userMessage ||
      'Δεν μπορέσαμε να προσθέσουμε την κάρτα σου! Προσπάθησε ξανά μέσα από τη σελίδα του προφίλ σου.';
    return { googleJwt: {}, gWalletError: userMessage };
  }
}

export async function postAppleWallet(card) {
  const authorization = cookies.get('token');
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  const body = {
    cardNumber: card,
  };
  const responseType = 'arraybuffer';
  try {
    const response = await wave.post('/v3/users/mobile-passes/apple-wallet', body, { headers, responseType });
    const { data } = response;
    const type = 'application/vnd.apple.pkpass';
    const passData = new Blob([data], { type });
    saveAs(passData, 'KritikosSM.pkpass');
    return { data };
  } catch (error) {
    const userMessage =
      error.response?.data?.userMessage ||
      'Δεν μπορέσαμε να προσθέσουμε την κάρτα σου! Προσπάθησε ξανά μέσα από τη σελίδα του προφίλ σου.';
    return { applePassWallet: {}, applePassError: userMessage };
  }
}
